<!-- <amplify-authenticator usernameAlias="email">
  <amplify-sign-up
    header-text="Login Amicare"
    slot="sign-up"
    usernameAlias="email"
    [formFields]="formFields"
  ></amplify-sign-up>
  <amplify-sign-in slot="sign-in" usernameAlias="email"></amplify-sign-in>
</amplify-authenticator> --> 

<div class="contenedor" *ngIf="authState !== 'signedin' && flagMostrarLogin "> 
  <div class="descarga">
    <a href="https://pharaonamicare2apk121350-staging.s3.eu-central-1.amazonaws.com/Amicare2_Pharaon.apk"> <u> descargar app </u> </a> 
</div>

<!-- <button class="signOut" (click)="signOut()">
  <mat-icon>exit_to_app</mat-icon>
</button> -->

<!-- <dash-button client-id="dash-button" realm="ecosystem-hub" keycloak-url="https://pharaon-dev-idp.eng.it"></dash-button> -->


<amplify-authenticator >

  <amplify-sign-in
  header-text="Login Amicare"
  slot="sign-in"
  secondary-footer-content="false"
>
<div slot="secondary-footer-content" display="none"></div>

</amplify-sign-in>

</amplify-authenticator>

<div *ngIf="authState === 'signedin' && user" class="App">


    <!-- This is where you application template code goes -->  
</div>

</div>
